// src/pages/Contact.jsx
import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import ContactBanner from "../components/ContactBanner";   // banner for contact page
import Footer from "../components/Footer";
import ContactSection from "../components/ContactSection";


const Contact = () => {
  return (
    <>
      <CustomNavbar />
      <ContactBanner />
      <ContactSection/>
      <Footer />
    </>
  );
};

export default Contact;
